import { setResetInterviewFormModal } from "../../../../../store/workspace/slice";
import { ResetSquareIcon } from "../../../../../assets/icons";
import { useDispatch } from "../../../../../store/store";
import Button from "../../../../../components/Button";
import Modal from "../../../../../components/Modal";
import styles from './style.module.scss';

interface Props {
    resetFunc: () => void;
};

export default function ConfirmResetInterviewForm(props: Props) {
    const { resetFunc } = props;
    const dispatch = useDispatch();

    const reset = () => {
        resetFunc();
        dispatch(setResetInterviewFormModal(false));
    };

    return (
        <Modal
            size='md'
            title='Reset to default list'
            icon={<ResetSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setResetInterviewFormModal(false))}
        >
            <div className={styles.content}>
                <span className={styles.content_title}>
                    Are you sure you want to reset your list to the default settings?
                </span>
                <p className={styles.content_attention}>
                    <b>Note:</b> Resetting your list will erase any changes you’ve made.
                </p>
            </div>
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Keep it'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setResetInterviewFormModal(false))}
                />
                <Button
                    type='Error'
                    text='Reset'
                    onClick={reset}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
